import noUiSlider from "nouislider/dist/nouislider.mjs";
import { Controller } from "@hotwired/stimulus";
import { isEmpty } from "underscore";

export default class extends Controller {
  static targets = ["slider", "input"];
  connect() {
    const start = (
      isEmpty(this.inputTarget.value) ? "0,30" : this.inputTarget.value
    ).split(",");
    this.noUiSlider = noUiSlider.create(this.sliderTarget, {
      start,
      tooltips: true,
      connect: true,
      step: 30,
      margin: 30,
      range: {
        min: -30,
        max: 90,
      },
      handleAttributes: [{ "aria-label": "lower" }, { "aria-label": "upper" }],
      pips: {
        mode: "steps",
        density: 20,
      },
      format: {
        // Receives a number, returns a string.
        to: function (value) {
          switch (value) {
            case -30: {
              return Math.abs(value) + " days ago";
            }
            case 0: {
              return "Today";
            }
            default: {
              return value + " days from now";
            }
          }
        },
        // Receives a string, returns a number.
        from: function (value) {
          switch (value) {
            case "30 days ago": {
              return -30;
            }
            case "Today": {
              return 0;
            }
            default: {
              return Number(value.replace(" days from now", ""));
            }
          }
        },
      },
    });

    this.sliderTarget.noUiSlider.on("change", (_values, _handle) => {
      const newValue = this.noUiSlider.get(true).join(",");
      if (newValue !== this.inputTarget.value) {
        this.inputTarget.value = newValue;
        this.inputTarget.dispatchEvent(new Event("input"));
      }
    });
  }
}
